/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import Layout from "../../layout/default";
import "./home.scss";
import OwnerCard from "../../component/Home/ownerCard";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import SwiperCore, { Navigation } from "swiper";
import ComplaintHome from "./complaint/index";
import RequestHome from "./requestHome/index";
import { getPropertyNameList } from "../../constants/config";
import { getOwnerList, upcommingBookings } from "../../constants/config";
import API from "../../services/api.service";
import { APIS } from "../../constants/apis";
import { lightenPast, villaHighlight } from "../../constants/villaColors";
import moment from "moment";
import DayTypeLegend from "../DayTypeLegend";
import {
  MAINTENANCE_BAR,
  fetchSpecialDays,
  specialDayClass,
  specialDayLabel,
  EMPTY_SPECIAL_DAYS,
  SpecialDayIndex,
} from "../../utils/dayTypes";
import OwnerListDD from "./ownerListDD";
import PropertyListDD from "./propertyListDD";
import { useAuth } from "../../store/context/login";
import PropertyHome from "./propertyHome";
import { NoDataComponent } from "../NoDataComponent";
import BookingDrawerComponent from "./bookingdrawer";
import NewBooking from "./newBooking";
import { Button, Modal } from "antd";
import { BookingSlotCalendar } from "@impulsiveweb/react-booking-calendar";
import "@impulsiveweb/react-booking-calendar/index.css";

type LayoutProps = {
  newFileList?: any;
};
SwiperCore.use([Navigation]);
const HomeComponent: FC<LayoutProps> = () => {
  const [bookingCardDetails, setBookingCardDetails] = useState<Array<any>>([]);
  const [ownerList, setOwnerList] = useState<any>([]);
  const [propertyList, setPropertyList] = useState<any>([]);
  // Creating / editing / cancelling bookings is staff-only; an owner signing into
  // the panel gets a read-only view of the same list.
  const { user, token, isManager } = useAuth();
  const [radioActive, setRadioActive] = useState(0);
  const [calendarData, setCalendarData] = useState<any[]>([]);
  const [showDrawer, setShowDrawer] = useState(false);
  const [drawerData, setDrawerData] = useState<any>(null);
  const [newBookingOpen, setNewBookingOpen] = useState(false);
  // The ids currently chosen in the active dropdown. The dropdowns are the
  // single source of truth for what the calendar shows; we keep the last
  // selection here so post-action refreshes (create/edit a booking) re-fetch
  // that same selection instead of falling back to "all".
  const [selectedIds, setSelectedIds] = useState<any>(0);
  // Calendar wrapper ref + the month it is currently showing (0-based, like the
  // widget's onMonthChange). Used to fade the date number on past-booking cells.
  const calRef = useRef<HTMLDivElement>(null);
  // Monotonic id for calendar fetches. Toggling Owners<->Properties (and rapid
  // dropdown changes) can start several overlapping requests; only the most
  // recent one is allowed to paint, so the colours don't flicker through stale
  // datasets before settling.
  const reqSeq = useRef(0);
  // Peak / High Peak days for the dashboard calendar. Global (not per-villa),
  // which is the only thing that makes sense here: this calendar spans several
  // villas at once, so a villa-scoped source has no single answer. Maintenance
  // and Booked are deliberately absent for the same reason — see the legend.
  const [specialDays, setSpecialDays] =
    useState<SpecialDayIndex>(EMPTY_SPECIAL_DAYS);
  useEffect(() => {
    fetchSpecialDays().then(setSpecialDays);
  }, []);
  // Maintenance days for the villas currently in view, drawn as SLOT BARS
  // alongside the booking bars rather than colouring the date number: several
  // villas share this calendar, and a date number can only be one colour, so
  // colouring it would hide every villa but one. Bars stack.
  const [maintSlots, setMaintSlots] = useState<any[]>([]);
  // YYYY-MM-DD -> every villa under maintenance that day, for the popup
  const [maintByDay, setMaintByDay] = useState<Record<string, any[]>>({});
  // the same days as a lookup, for colouring the date number
  const [maintDays, setMaintDays] = useState<Set<string>>(new Set());
  const [maintPopup, setMaintPopup] = useState<any>(null);
  const [dispYear, setDispYear] = useState<number>(new Date().getFullYear());
  const [dispMonth, setDispMonth] = useState<number>(new Date().getMonth());
  const getDropDownData = async () => {
    const own = await getOwnerList();
    const prt = await getPropertyNameList();
    setOwnerList(own.data.data);
    setPropertyList(prt.data.data);
  };

  useEffect(() => {
    // Only load the dropdown lists here. The calendar's data comes from
    // whichever dropdown is mounted (Owners/Properties) via its default
    // selection, so Home no longer fetches "all" on mount — doing so raced the
    // dropdown's filtered fetch and left the calendar showing every owner while
    // the dropdown said "3 selected".
    getDropDownData();
  }, [token]);

  const showBookingDetails = (slot: any) => {
    // Maintenance bars share this handler; they are not bookings, so send them
    // to their own popup instead of a lookup that could never match.
    if (typeof slot.id === "string" && slot.id.startsWith("maint-")) {
      const day = String(slot.startDate).slice(0, 10);
      setMaintPopup({ day, items: maintByDay[day] || [] });
      return;
    }
    const index = bookingCardDetails.findIndex((bc) => bc.id === slot.id);
    if (index > -1) {
      setDrawerData(bookingCardDetails[index]);
      setShowDrawer(true);
    }
  };

  // Maintenance for the villas the current filter is showing, so the calendar
  // stays one coherent view. Villa TITLES are carried through from the same
  // responses that give us the ids — owner-properties already returns
  // { id, title } — rather than looked up in propertyList, which may not have
  // loaded yet on the first call and left the popup saying "this villa".
  const loadMaintenance = async (type: string, ids: any) => {
    const idList: number[] = Array.isArray(ids) ? ids : ids ? [ids] : [];
    const clear = () => {
      setMaintSlots([]);
      setMaintByDay({});
      setMaintDays(new Set());
    };
    try {
      let villas: Array<{ id: number; title: string }> = [];
      if (type === "properties") {
        // Properties view selects ids only, so titles come from the dropdown's
        // own list — fetched here if this runs before that list has landed.
        let list = propertyList;
        if (!list || list.length === 0) {
          const r: any = await getPropertyNameList();
          list = r?.data?.data || [];
        }
        villas = idList
          .map((pid) => list.find((p: any) => Number(p.id) === Number(pid)))
          .filter(Boolean)
          .map((p: any) => ({ id: p.id, title: p.title }));
      } else {
        const lists = await Promise.all(
          idList.map((oid) =>
            API.get(APIS.HOME.OWNER_PROPERTIES + oid)
              .then((r: any) => (r.data.status === 1 ? r.data.data || [] : []))
              .catch(() => [])
          )
        );
        const seen = new Set<number>();
        lists.flat().forEach((p: any) => {
          if (p && !seen.has(Number(p.id))) {
            seen.add(Number(p.id));
            villas.push({ id: p.id, title: p.title });
          }
        });
      }
      if (villas.length === 0) return clear();

      const perVilla = await Promise.all(
        villas.map((v) =>
          API.get(APIS.USER_MANAGEMENT.LIST_MAINTENANCE_DAY + v.id)
            .then((r: any) =>
              r.data.status === 1
                ? (r.data.data || []).map((d: any) => ({ ...d, villa: v.title }))
                : []
            )
            .catch(() => [])
        )
      );

      const slots: any[] = [];
      // Bars stack, so a click can't tell you WHICH bar you hit — key the popup
      // by day and show every villa under maintenance that day.
      const byDay: Record<string, any[]> = {};
      perVilla.flat().forEach((d: any) => {
        const day = moment(d.date).format("YYYY-MM-DD");
        slots.push({
          id: `maint-${d.id}`,
          color: MAINTENANCE_BAR,
          startDate: day,
          endDate: day,
        });
        (byDay[day] = byDay[day] || []).push({
          villa: d.villa,
          remarks: d.remarks || "",
        });
      });
      setMaintSlots(slots);
      setMaintByDay(byDay);
      setMaintDays(new Set(Object.keys(byDay)));
    } catch (e) {
      clear();
    }
  };

  const getCardData = async (ids?: any, value?: any, option?: any) => {
    let type = "owners";
    if (radioActive === 1 || option === 1) type = "properties";
    else type = "owners";
    loadMaintenance(type, ids);

    // Only the latest request may update state; drop responses that a newer
    // fetch has already superseded (prevents the Owners->Properties colour flicker).
    const seq = ++reqSeq.current;
    const result = await upcommingBookings(type, ids, token);
    if (seq !== reqSeq.current) return;

    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);

    // Keep ALL bookings here (incl. past) so clicking a past greyed calendar bar
    // still opens its details drawer. The visible card LIST is filtered to
    // current/upcoming in the render below.
    setBookingCardDetails(result.data.data.rows);

    // Past bookings (checked out before today) use a LIGHTER tint of the villa's
    // colour; current/upcoming use the full villa colour. Past date numbers are
    // also faded (the .cld_past tagging effect + rule in home.scss).
    const cd = result.data.data.rows.map((row: any) => {
      const isPast = new Date(row.end_date) < startOfToday;
      return {
        id: row.id,
        color: isPast
          ? lightenPast(row.propertyDetails?.color)
          : villaHighlight(row.propertyDetails?.color),
        startDate: row.start_date,
        endDate: row.end_date,
      };
    });
    setCalendarData(cd);
  };
  // No view-switch effect: the Owners/Properties dropdowns are conditionally
  // rendered, so toggling unmounts one and mounts the other, and the freshly
  // mounted dropdown fetches its own default selection. A Home-level refetch
  // here would race that and re-introduce the "shows all / says 3 selected"
  // mismatch (and, with -1, blank the Properties view).

  // Two jobs, both done by tagging the widget's DOM because BookingSlotCalendar
  // takes no day renderer (its props are slots / month / year only):
  //   1. fade the DATE NUMBER on past-booking cells — past and upcoming bars
  //      share the villa colour, so the number is what tells them apart;
  //   2. colour Peak / High Peak dates and give them a hover tooltip, the same
  //      markers the New booking picker shows.
  // Runs after the calendar commits its DOM for the month, and again whenever
  // its data, month or the special-days index changes.
  useEffect(() => {
    const root = calRef.current;
    if (!root) return;
    const mark = () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      root.querySelectorAll(".cld_element").forEach((cell: any) => {
        const valEl = cell.querySelector(".cld_date_val");
        const hasBooking = !!cell.querySelector(".cld_date_bg");
        const day = valEl ? parseInt(valEl.textContent || "", 10) : 0;
        const isPast =
          hasBooking && !!day && new Date(dispYear, dispMonth, day) < today;
        cell.classList.toggle("cld_past", isPast);

        if (!valEl || !day) return;
        // specialDayClass takes a moment-like value; the widget only gives us
        // the day number, so rebuild the date from the month on display.
        const m = moment(new Date(dispYear, dispMonth, day));
        // Maintenance outranks Peak on the date number, the same precedence the
        // New booking picker uses: a blocking state beats a rate marker.
        const isMaint = maintDays.has(m.format("YYYY-MM-DD"));
        const cls = isMaint ? "cell_maint" : specialDayClass(m, specialDays);
        valEl.classList.remove("cell_peak", "cell_high_peak", "cell_maint");
        if (cls) valEl.classList.add(cls);
        const label = isMaint ? "Maintenance day" : specialDayLabel(cls);
        if (label) valEl.setAttribute("title", label);
        else valEl.removeAttribute("title");
      });
    };
    // run after the widget commits its DOM for this month
    const id = window.setTimeout(mark, 0);
    return () => window.clearTimeout(id);
  }, [calendarData, dispYear, dispMonth, specialDays, maintDays]);

  const dateFormater = () => {
    let currentdate = new Date();
    const weekday = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const month = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var datetime =
      weekday[currentdate.getDay()] +
      ", " +
      currentdate.getDate() +
      "th " +
      month[currentdate.getMonth()] +
      " " +
      currentdate.getFullYear();
    return datetime;
  };

  return (
    <Layout>
      <div className="home_container">
        <div className="home_left_part">
          {!!user && (
            <div className="home_heading">
              Welcome {user.first_name} {user.last_name}
            </div>
          )}
          {!!user && (
            <div className="home_sub_heading">
              Here are your updates for
              <span className="home_sub_span"> {dateFormater()}</span>
            </div>
          )}
          <div className="complaints_card">
            <ComplaintHome />
            <RequestHome />
            <PropertyHome />
          </div>
        </div>
        <div className="home_right_part">
          <div
            className="heading_right"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingRight: 24,
            }}
          >
            <span>Upcoming bookings</span>
            {isManager && (
              <Button
                type="primary"
                size="small"
                onClick={() => setNewBookingOpen(true)}
                style={{ background: "#082017", borderColor: "#082017" }}
              >
                New booking
              </Button>
            )}
          </div>
          <div className="container">
            <div className="checkbox_drop_down">
              <div className="checkbox">
                <div className="choose_view">Choose view </div>
                <div className="chekbox_list">
                  <div
                    className={`radio_btn_options ${
                      radioActive == 0 ? "active" : ""
                    }`}
                    onClick={() => {
                      // Just switch the view. The Owner dropdown mounts and
                      // fetches its own default selection; fetching here too
                      // would race it and paint stale colours first.
                      setRadioActive(0);
                    }}
                  >
                    <div className="radio_btn_input_container">
                      <img
                        src="/images/radio_active.svg"
                        className="radio_inactive"
                        alt=""
                      />
                      <img
                        src="/images/radio_inactive.svg"
                        className="radio_active"
                        alt=""
                      />
                    </div>
                    <div className="label">Owner</div>
                  </div>
                  <div
                    className={`radio_btn_options ${
                      radioActive == 1 ? "active" : ""
                    }`}
                    onClick={() => {
                      // Just switch the view; the Property dropdown mounts and
                      // fetches its own default selection (see Owner above).
                      setRadioActive(1);
                    }}
                  >
                    <div className="radio_btn_input_container">
                      <img
                        src="/images/radio_active.svg"
                        className="radio_inactive"
                        alt=""
                      />
                      <img
                        src="/images/radio_inactive.svg"
                        className="radio_active"
                        alt=""
                      />
                    </div>
                    <div className="label">Properties</div>
                  </div>
                </div>
              </div>
              <div className="drop_down">
                {radioActive === 0 && (
                  <OwnerListDD
                    width={"190.6px"}
                    data={ownerList}
                    getData={(id: any) => {
                      setSelectedIds(id);
                      getCardData(id);
                    }}
                    showClear={true}
                    multi={true}
                    maxSelect={3}
                    customClass={"drop_down_custom"}
                    title={" Owner"}
                    defaultSelect={true}
                  />
                )}
                {radioActive === 1 && (
                  <PropertyListDD
                    width={"190.6px"}
                    data={propertyList}
                    getData={(id: any) => {
                      setSelectedIds(id);
                      getCardData(id);
                    }}
                    showClear={true}
                    customClass={"drop_down_custom"}
                    multi={true}
                    maxSelect={3}
                    defaultSelect={true}
                  />
                )}
              </div>
            </div>
            <div className="booking_container_box" ref={calRef}>
              {/* Booked stays hidden: a booking is already shown as its own
                  villa-coloured bar, so a swatch would say nothing new. */}
              <DayTypeLegend showBooked={false} />
              <BookingSlotCalendar
                slots={[...calendarData, ...maintSlots]}
                activeMonth={new Date().getMonth() + 1}
                activeYear={new Date().getFullYear()}
                onMonthChange={(y: number, m: number) => {
                  setDispYear(y);
                  setDispMonth(m);
                }}
                onSlotClick={showBookingDetails}
              />
              {/* <SlotCalendarComponent
                slots={calendarData}
                activeMonth={new Date().getMonth() + 1}
                activeYear={new Date().getFullYear()}
                hideOtherMonth={true}
                onSlotClick={showBookingDetails}
              ></SlotCalendarComponent> */}
            </div>

            {bookingCardDetails !== null &&
              (() => {
                // Card LIST shows only current & upcoming bookings. Past
                // bookings stay clickable on the calendar above (the drawer
                // lookup uses the full bookingCardDetails, unfiltered).
                const startOfDay = new Date();
                startOfDay.setHours(0, 0, 0, 0);
                const upcomingCards = bookingCardDetails.filter(
                  (r: any) => new Date(r.end_date) >= startOfDay
                );
                return upcomingCards.length > 0 ? (
                  <div className="booking_container">
                    {upcomingCards.map((val: any, ind: any) => {
                      return (
                        <div
                          onClick={() => {
                            setShowDrawer(true);
                            setDrawerData(val);
                          }}
                        >
                          {val.status !== 0 && (
                            <OwnerCard key={ind} data={val} />
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <NoDataComponent upComing="upcoming bookings" />
                );
              })()}

            <BookingDrawerComponent
              data={drawerData}
              setShowDrawer={setShowDrawer}
              showDrawer={showDrawer}
              onUpdate={getCardData}
              param={selectedIds}
            />
            {/* Clicking a maintenance bar: it is not a booking, so it gets a
                details popup rather than the booking drawer. Bars stack, so the
                popup lists every villa under maintenance that day rather than
                guessing which bar was clicked. */}
            <Modal
              visible={!!maintPopup}
              onCancel={() => setMaintPopup(null)}
              footer={null}
              destroyOnClose
              width={400}
            >
              <div style={{ fontSize: 18, fontWeight: 700 }}>
                Maintenance day
              </div>
              <div style={{ color: "#4b5563", marginTop: 4, marginBottom: 20 }}>
                {maintPopup ? moment(maintPopup.day).format("ddd, D MMM YYYY") : ""}
              </div>
              {(maintPopup?.items || []).map((it: any, i: number) => (
                <div
                  key={i}
                  style={{
                    paddingTop: 12,
                    paddingBottom: 12,
                    borderTop: i ? "1px solid #eceeed" : "none",
                  }}
                >
                  <div style={{ fontWeight: 600 }}>{it.villa}</div>
                  <div style={{ color: "#4b5563", marginTop: 4 }}>
                    {it.remarks || "No remarks"}
                  </div>
                </div>
              ))}
            </Modal>
            <NewBooking
              open={isManager && newBookingOpen}
              onClose={() => setNewBookingOpen(false)}
              onCreated={() => getCardData(selectedIds)}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HomeComponent;
